export enum SettingsActionTypes {
    DEVICE_DETECTION = 'DEVICE_DETECTION',
    PLATFORM_DETECTION = 'PLATFORM_DETECTION',
}
